import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'idrCurrency'
})
export class IdrCurrencyPipe implements PipeTransform {
  transform(value: number | string, showPrefix: boolean = true): string {
    if (value == null || value === '') return '-';

    const num = Number(value);
    if (isNaN(num)) return String(value);

    // Format with thousand separator (.)
    const formatted = num
      .toFixed(0) // remove decimals
      .replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    return showPrefix ? `Rp ${formatted}` : formatted;
  }
}
